import { Chip } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import PolicyAvatar from './policy-avatar';

import { GenericCardHeader } from '~/client/components/base/generic-card';
import * as GQL from '~/graphql/generated/client';

interface Props {
  className?: string;
  policy: GQL.PolicyFragment | GQL.ControlBundleFragment;
  avatar?: React.ReactNode;
}

const PolicyCardHeaderImpl: React.FC<Props> = ({
  className,
  policy,
  avatar,
}) => {
  const hasLabels = policy?.labels && policy.labels.length > 0;

  // If no labels, return null to avoid rendering empty header
  if (!hasLabels) {
    return null;
  }
  return (
    <GenericCardHeader
      action={
        <div>
          {policy?.labels?.map((label, index) => {
            return (
              index <= 0 && (
                <Chip
                  key={label}
                  label={label}
                  variant="outlined"
                  style={{
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                  }}
                />
              )
            );
          })}
        </div>
      }
    />
  );
};

export const PolicyCardHeader = muiStyled(PolicyCardHeaderImpl)(
  ({ theme }) => css``
);

export default PolicyCardHeader;
